import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import FormLabel from 'react-bootstrap/FormLabel';
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';

import { useUser, login } from '../context/UserContext';
import { createPostageUser, fetchUserDetailsByNetId } from '../services/api';


function NewUserForm(){
    const navigate = useNavigate();
    const { newNetId } = useParams();

    const { login } = useUser();
    const { netId } = useParams();

    const [ error, setError ] = useState('');
    const [ success, setSuccess ] = useState('');

    const [ newUser, setNewUser ] = useState({
        netId: newNetId,
        firstName: '',
        lastName: '',
        department: '',
        boxNumber: '',
        phone: '',
    });

    const handleChange = (e) => {
        setNewUser({ ...newUser, [e.target.name]: e.target.value });
        console.log(newUser);
    };

    const registerNewUser = async () =>{
        try {            
            const newUser = await createPostageUser(newUser);
            login(newUser);
        } catch (creationError) {
            console.error("Error creating new user:", creationError);
        }
    };
    
    return(
        <div class="container">
            <div className='page-header'>
                <h1 className='gradient-under'>New User</h1>
            </div>
            {error && <div className="alert alert-danger">{error}</div>}
            {success && <div className="alert alert-success">{success}</div>}
            <form onSubmit={registerNewUser} className="mt-3">
                <div className="mb-3">
                    <label htmlFor="firstName" className="form-label">First Name</label>
                    <input type="text" className="form-control" id="firstName" name="firstName" value={newUser.firstName || ''} onChange={handleChange} />
                </div>
                <div className="mb-3">
                    <label htmlFor="lastName" className="form-label">Last Name</label>
                    <input type="text" className="form-control" id="lastName" name="lastName" value={newUser.lastName || ''} onChange={handleChange} />
                </div>
                <div className="mb-3">
                    <label htmlFor="department" className="form-label">Department</label>
                    <input type="text" className="form-control" id="department" name="department" value={newUser.department || ''} onChange={handleChange} />
                </div>
                <div className="mb-3">
                    <label htmlFor="boxNumber" className="form-label">Box Number</label>
                    <input type="text" className="form-control" id="boxNumber" name="boxNumber" value={newUser.boxNumber || ''} onChange={handleChange} />
                </div>
                <div className="mb-3">
                    <label htmlFor="phone" className="form-label">Phone <em>(10-digit numbers only, no symbols)</em></label>
                    <input type="tel" className="form-control" id="phone" name="phone" pattern="[0-9]{10}" value={newUser.phone || ''} onChange={handleChange} />
                </div>
                <button type="submit" className="btn btn-primary">Create User</button>
            </form>
        </div>
    );
}

export default NewUserForm;